<template>
  <mdb-row>
    <mdb-col>
      <mdb-select
        search
        @getValue="getSelectValue"
        v-if="loadReady"
        v-model="radiusOptions"
        :visibleOptions="6"
        :label="$t('notification_radius')"
        :placeholder="$t('choose_notification_radius')"
      />
    </mdb-col>
  </mdb-row>
</template>

<script>
import { mdbSelect, mdbCol, mdbRow } from "mdbvue";

export default {
  name: "NotificationRadiusSelection",
  components: {
    mdbSelect,
    mdbCol,
    mdbRow,
  },
  props: {
    defaultSelection: String,
  },
  data: () => ({
    loadReady: false,
    labelOptions: [],
    radiusOptions: [
      {
        text: "1 km",
        value: 1,
      },
      {
        text: "2 km",
        value: 2,
      },
      {
        text: "3 km",
        value: 3,
      },
      {
        text: "5 km",
        value: 5,
      },
      {
        text: "7 km",
        value: 7,
      },
      {
        text: "10 km",
        value: 10,
      },
      {
        text: "15 km",
        value: 15,
      },
      {
        text: "20 km",
        value: 20,
      },
      {
        text: "30 km",
        value: 30,
      },
      {
        text: "40 km",
        value: 40,
      },
      {
        text: "50 km",
        value: 50,
      },
      {
        text: "70 km",
        value: 70,
      },
      {
        text: "100 km",
        value: 100,
      },
      {
        text: "200 km",
        value: 200,
      },
      {
        text: "300 km",
        value: 300,
      },
      {
        text: "500 km",
        value: 500,
      },
      {
        text: "700 km",
        value: 700,
      },
      {
        text: "1000 km",
        value: 1000,
      },
      {
        text: "1500 km",
        value: 1500,
      },
    ],
  }),
  methods: {
    createSelect() {

    },
    getSelectValue(val) {
      this.$emit("notification_radius", val);
    },
  },
  watch: {
    content: function (newVal, oldVal) {
      if (newVal !== null) {
        this.createSelect();
      }
      console.log("Prop changed: ", newVal, " | was: ", oldVal);
    },
  },
  mounted() {
    this.createSelect();
    this.loadReady = true;
  },
};
</script>

<style>
</style>
